// extracted by mini-css-extract-plugin
module.exports = {"ad":"MobileBanner_ad__Ta3Wh"};